import { Clock, RefreshCw, VideoOff } from "lucide-react";

function StreamNotStarted() {
  return (
    <div className="min-h-[calc(100vh-70px)] bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <div className="max-w-xl w-full">
        {/* Main Card */}
        <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
          {/* Icon */}
          <div className="mb-6 flex justify-center">
            <div className="relative">
              <div className="absolute inset-0 bg-yellow-400 rounded-full opacity-20 animate-ping"></div>
              <div className="relative bg-yellow-100 p-4 rounded-full">
                <VideoOff className="w-12 h-12 text-yellow-600" />
              </div>
            </div>
          </div>

          {/* Heading */}
          <h1 className="text-2xl md:text-3xl font-bold text-slate-800 mb-3">
            Stream Not Started Yet
          </h1>

          {/* Description */}
          <p className="text-slate-600 mb-6 leading-relaxed">
            The live stream hasn’t begun yet. Please wait for the host to start
            the session or refresh your connection once the stream goes live.
          </p>

          {/* Status Info */}
          <div className="bg-slate-50 rounded-xl p-4 mb-6 space-y-3">
            <div className="flex items-center justify-between text-sm">
              <div className="flex items-center gap-2">
                <Clock className="w-4 h-4 text-slate-500" />
                <span className="text-slate-700">Stream Status</span>
              </div>
              <span className="text-yellow-600 font-medium">Pending</span>
            </div>

            <div className="flex items-center justify-between text-sm">
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 border-2 border-slate-400 rounded"></div>
                <span className="text-slate-700">Next Check</span>
              </div>
              <span className="text-slate-500 font-medium">Waiting...</span>
            </div>
          </div>

          {/* Retry Button */}
          <button
            onClick={() => window.location.reload()}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2 mb-4"
          >
            <RefreshCw className="w-5 h-5 animate-spin-slow" />
            Refresh Stream
          </button>

          {/* Help Text */}
          <p className="text-xs text-slate-500">
            The stream will start automatically once the host begins
            broadcasting.
          </p>
        </div>
      </div>
    </div>
  );
}

export default StreamNotStarted;
